<template>
  <Header>
    <Poptip
      placement="bottom"
      width="600"
      class="mini_menu hoverIcon"
      :style="{ 'margin-right': '1rem' }"
    >
      <Icon
        type="ios-apps"
        size="28"
        style="vertical-align: middle; padding: 0px 10px"
      ></Icon>
      <div class="api contentBox" slot="content">
        <div class="iconBox">
          <img
            shape="square"
            size="large"
            :src="homeImg"
            :onerror="placeHoldImg"
            @click="toMain()"
          />
          <p>首页</p>
        </div>
        <div
          class="iconBox"
          v-for="(item, index) in appList"
          :key="index"
          @click="toTarget(item, index)"
        >
          <img
            shape="square"
            size="large"
            :src="item.icon"
            :onerror="placeHoldImg"
          />
          <p v-text="item.title"></p>
        </div>
      </div>
    </Poptip>
    <!-- <div class="search">
      <Input
        class="headinput"
        style="width: 300px;"
        search
        enter-button
        placeholder="输入你想搜索的内容"
        v-show="isShow"
      />
      <Icon
        type="md-search"
        size="24"
        class="topSearch hoverIcon"
        @click="isShow = !isShow"
      />
    </div> -->
    <Poptip placement="bottom" class="source hoverIcon">
      <Badge :count="0" class="notice">
        <Icon type="ios-notifications-outline" size="28"></Icon>
      </Badge>
      <div class="api contentBox" slot="content">
        <!-- <List size="large">
          <ListItem>
            <ListItemMeta
              avatar="https://dev-file.iviewui.com/userinfoPDvn9gKWYihR24SpgC319vXY8qniCqj4/avatar"
              title="蒂姆·库克回复了你的邮件"
              description="2019-05-08 14:33:18"
            />
          </ListItem>
          <ListItem>
            <ListItemMeta
              avatar="https://dev-file.iviewui.com/userinfoPDvn9gKWYihR24SpgC319vXY8qniCqj4/avatar"
              title="乔纳森·伊夫邀请你参加会议"
              description="2019-05-08 14:33:18"
            />
          </ListItem>
        </List> -->
        <Button class="w-100" type="text" @click="toMessage()">消息中心</Button>
      </div>
    </Poptip>
    <div class="hoverIcon user_case d-flex">
      <div class="demo-avatar userInfo mr-3">
        <Avatar style="background-color: #87d068" icon="ios-person" />
      </div>
      <Dropdown class="dropdownbox" @on-click="menuClick">
        <a href="javascript:void(0)" class="name">
          {{ user.name }}
          <Icon type="ios-arrow-down"></Icon>
        </a>
        <DropdownMenu slot="list">
          <DropdownItem name="personalCenter">个人中心</DropdownItem>
          <DropdownItem name="loginOut">退出登录</DropdownItem>
        </DropdownMenu>
      </Dropdown>
    </div>
  </Header>
</template>
<script>
import $axios from "../../utils/axios";
export default {
  name: "YnHeader",
  data() {
    return {
      isCollapsed: false,
      currentIndex: 0,
      isShow: false,
      appList: [],
    };
  },
  props: {
    user: {
      type: Object,
      default() {
        return {};
      },
    },
    homeImg: {
      type: String,
      default() {
        return "";
      },
    },
    placeHoldImg: {
      type: String,
      default() {
        return "";
      },
    },
  },
  computed: {
    rotateIcon() {
      return ["menu-icon", this.isCollapsed ? "rotate-icon" : ""];
    },
    menuitemClasses() {
      return ["menu-item", this.isCollapsed ? "collapsed-menu" : ""];
    },
    // user() {
    //   return this.$store.state.user;
    // },
  },
  methods: {
    collapsedSider() {
      this.$refs.side1.toggleCollapse();
    },
    // getApp() {
    //   var config = JSON.parse(localStorage.getItem("config"));
    //   $axios({
    //     baseURL: config.tyrz,
    //     url: "schApp/person",
    //     method: "GET",
    //   }).then((res) => {
    //     if (res.code == 200) {
    //       this.appList = res.data;
    //     }
    //   });
    // },

    getApp() {
      var config = JSON.parse(localStorage.getItem("config"));
      $axios({
        baseURL: config.tyrz,
        url: "desktop",
        method: "GET",
      }).then((res) => {
        if (res.code == 200) {
          this.appList = res.data;
          // this.$store.commit('setDesktopGroup', res.data);
        }
      });
    },

    toMain() {
      var config = JSON.parse(localStorage.getItem("config"));
      location.href = `${config.mainWeb}/main`;
    },
    toMessage() {
      var config = JSON.parse(localStorage.getItem("config"));
      location.href = `${config.message}/?config=${config.tyrz}/menu/config&appId=101&token=${localStorage.getItem("token")}`;
    },

    toTarget(item, index) {
      console.log(JSON.stringify(item));
      var token = localStorage.getItem("token");
      var config = JSON.parse(localStorage.getItem("config"));
      if (item.appType == 0) {
        window.location.href = `${config.mainWeb}/mainSecond?index=${index}`;
      } else {
        var url = `${item.url}?config=${config.tyrz}/menu/config&appId=${item.appId}&token=${token}`;
        window.location.href = url;
      }
    },

    // toUrl(url) {
    //   location.href = url;
    // },
    menuClick(name) {
      var self = this;
      if (name == "loginOut") {
        this.$Modal.confirm({
          title: "退出",
          content: "确认退出当前账户么?",
          onOk: function () {
            // self.$emit("dropClick", "loginOut");
            var config = JSON.parse(localStorage.getItem("config"));

            $axios({
              baseURL: config.tyrz,
              method: "POST",
              url: "/Account/LoginOut",
              data: {
                clientId: "tyrz",
                token: localStorage.getItem("token"),
              },
              withCredentials: false,
            })
              .then((res) => {
                localStorage.clear();
                window.location.href = res.data + "/?isExit=true";
              })
              .catch((res) => {
                alert(res.msg);
              });
          },
        });
      }
      if (name == "personalCenter") {
        var config = JSON.parse(localStorage.getItem("config"));
        location.href = `${config.personCenter}/?config=${config.tyrz}/menu/config&appId=101token=${localStorage.getItem("token")}`;
      }
    },
  },
  created() {
    this.getApp();
  },
};
</script>
<style lang="less" scoped>
.ivu-layout-header {
  display: flex;
  height: 60px;
  line-height: 60px;
  background-color: #fff;
  .mini_menu {
    .ivu-icon {
      padding: 0 !important;
    }
    .iconBox {
      float: left;
      width: 20%;
      text-align: center;
      margin: 20px 0;
      img {
        width: 75px;
        height: 75px;
        border-radius: 15px;
        box-shadow: 0 4px 9px rgba(0, 0, 0, 0.25);
      }
      p {
        text-align: center;
      }
    }
  }
  .search {
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 1.5rem;
    .headinput {
      margin-right: 1rem;
      margin-left: 1rem;
    }
  }
  .source {
    .notice {
      i {
        vertical-align: middle;
      }
    }
  }
  .user_case {
    margin: 0 2rem;
    .userInfo {
    }
  }
  .hoverIcon:hover {
    background-color: #f8f8fb;
  }
}
</style>
